import { useEffect, useMemo, useState } from "react"
import { FUNNEL_SCENES, tutorFacesScene } from "./funnelScenes"

const EMPTY_SCENE = { layers: [] }

/**
 * La révélation des masteurs, partagée par les funnels qui racontent la
 * recherche : le vivier se pose dans la scène visage par visage dès que le
 * matching l'a servi (les retenus cerclés une fois la recherche finie), et le
 * nombre annoncé monte de 0 à N pendant l'entrée des cartes — un résultat se
 * lit comme un résultat, pas comme un titre.
 *
 * Tant que le matching cherche, le bandeau reste nu : un visage de repli qui
 * s'efface au profit des vrais ferait un flash. Sans vivier (repli), la scène
 * de référence.
 */
export const useFunnelTutorReveal = ({ loading, matching, searching }) => {
    const showcase = matching?.showcase || []

    const [shownCount, setShownCount] = useState(0)
    useEffect(() => {
        if (searching || !matching?.count) return undefined
        const target = matching.count
        const startedAt = Date.now()
        // Une dizaine de pas suffisent à faire monter le chiffre ; chaque pas
        // est un rendu de l'écran entier pendant que les cartes entrent.
        const tick = setInterval(() => {
            const k = Math.min(1, (Date.now() - startedAt) / 900)
            const eased = 1 - Math.pow(1 - k, 3)
            setShownCount(Math.round(target * eased))
            if (k >= 1) clearInterval(tick)
        }, 80)
        return () => clearInterval(tick)
    }, [searching, matching?.count])

    const fieldAvatars = useMemo(
        () => [
            ...new Set([
                ...showcase.map((t) => t.avatar),
                ...(matching?.more_avatars || []),
            ]),
        ],
        [showcase, matching]
    )

    const scene = useMemo(() => {
        if (fieldAvatars.length >= 3)
            return tutorFacesScene(
                fieldAvatars,
                searching ? [] : showcase.map((t) => t.avatar),
                Object.fromEntries(
                    showcase.map((t) => [t.avatar, t.title_skill_set_id])
                )
            )
        if (loading) return EMPTY_SCENE
        return FUNNEL_SCENES.tuteurs
    }, [fieldAvatars, loading, searching, showcase])

    return { showcase, shownCount, scene }
}
